(function () {
  "use strict";

  if (!window.DNB) {
    return;
  }

  window.DNB.register(function () {
    window.DNB.scroller = null;
    window.DNB.locoScroll = null;

    if (window.gsap && window.ScrollTrigger) {
      window.gsap.registerPlugin(window.ScrollTrigger);
    }

    var scrollContainer = document.querySelector("[data-scroll-container]");
    var isMobile =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(max-width: 640px)").matches;
    var prefersReducedMotion = false;
    if (window.matchMedia) {
      prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }
    window.DNB.prefersReducedMotion = prefersReducedMotion;

    var useContainer = false;
    if (scrollContainer) {
      var containerStyle = window.getComputedStyle(scrollContainer);
      var overflowY = containerStyle.overflowY || containerStyle.overflow || "";
      var allowScroll = /auto|scroll|overlay/.test(overflowY);
      var htmlStyle = window.getComputedStyle(document.documentElement);
      var bodyStyle = window.getComputedStyle(document.body);
      var bodyLocked =
        !isMobile && (/hidden|clip/.test(htmlStyle.overflowY) || /hidden|clip/.test(bodyStyle.overflowY));

      useContainer = bodyLocked || allowScroll;
    }

    var scroller = useContainer ? scrollContainer : null;

    var resolveTarget = function (target) {
      if (typeof target === "number") {
        return target;
      }
      if (typeof target === "string") {
        return document.querySelector(target);
      }
      if (target && target.nodeType === 1) {
        return target;
      }
      return null;
    };

    var canUseLenis = !!window.Lenis && !prefersReducedMotion && !useContainer && !isMobile;
    var lenis = null;

    if (canUseLenis) {
      try {
        lenis = new window.Lenis({
          smooth: true,
          lerp: 0.08,
          smoothWheel: true,
          smoothTouch: false
        });
      } catch (error) {
        lenis = null;
      }
    }

    if (lenis) {
      window.DNB.lenis = lenis;

      if (window.ScrollTrigger) {
        lenis.on("scroll", window.ScrollTrigger.update);
      }

      if (window.gsap && window.gsap.ticker) {
        window.gsap.ticker.add(function (time) {
          lenis.raf(time * 1000);
        });
        window.gsap.ticker.lagSmoothing(0);
      } else {
        var raf = function (time) {
          lenis.raf(time);
          window.requestAnimationFrame(raf);
        };
        window.requestAnimationFrame(raf);
      }

      document.documentElement.style.scrollBehavior = "auto";

      window.DNB.locoScroll = {
        scrollTo: function (target, options) {
          var resolved = resolveTarget(target);
          var duration = options && typeof options.duration === "number" ? options.duration : null;
          var immediate =
            prefersReducedMotion ||
            duration === 0 ||
            (options && options.disableLerp === true);
          var lenisOptions = { immediate: immediate };

          if (duration !== null) {
            lenisOptions.duration = duration;
          }

          lenis.scrollTo(resolved !== null ? resolved : target, lenisOptions);
        },
        update: function () {
          if (typeof lenis.resize === "function") {
            lenis.resize();
          } else if (typeof lenis.update === "function") {
            lenis.update();
          }
          if (window.ScrollTrigger) {
            window.ScrollTrigger.refresh();
          }
        }
      };

      if (window.ScrollTrigger) {
        window.ScrollTrigger.refresh();
      }

      return;
    }

    if (scroller) {
      window.DNB.scroller = scroller;
      if (window.ScrollTrigger) {
        window.ScrollTrigger.defaults({ scroller: scroller });
      }
    }

    var smoothRoot = scroller || document.documentElement;
    if (smoothRoot) {
      smoothRoot.style.scrollBehavior = prefersReducedMotion ? "auto" : "smooth";
    }

    var scrollToTarget = function (target, options) {
      var resolved = resolveTarget(target);
      var duration = options && typeof options.duration === "number" ? options.duration : 0;
      var behavior = prefersReducedMotion || duration === 0 ? "auto" : "smooth";
      var top = 0;

      if (typeof resolved === "number") {
        top = resolved;
      } else if (resolved && resolved.getBoundingClientRect) {
        if (scroller) {
          top =
            resolved.getBoundingClientRect().top -
            scroller.getBoundingClientRect().top +
            scroller.scrollTop;
        } else {
          top = resolved.getBoundingClientRect().top + window.pageYOffset;
        }
      }

      if (scroller) {
        scroller.scrollTo({ top: top, behavior: behavior });
      } else {
        window.scrollTo({ top: top, behavior: behavior });
      }
    };

    var update = function () {
      if (window.ScrollTrigger) {
        window.ScrollTrigger.refresh();
      }
    };

    window.DNB.locoScroll = {
      scrollTo: scrollToTarget,
      update: update
    };

    if (window.ScrollTrigger) {
      window.ScrollTrigger.refresh();
    }
  });
})();
